import { Provider } from 'mobx-react';
import * as React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { muiTheme } from './core/theme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import Composer from "./components/Composer/Composer";
import registerServiceWorker from "./services/registerServiceWorker";

import { todoListStore, todoStore } from './stores/data-store';

import "./index.css";

ReactDOM.render(
	<AppContainer>
			<Provider todoListStore={todoListStore}>
				<MuiThemeProvider muiTheme={ muiTheme }>
					<Composer />
				</MuiThemeProvider>
			</Provider>
	</AppContainer>,
	document.getElementById("root")
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js